import React, { useContext } from 'react';
import cn from 'classnames';

import { UiKit } from 'components';
import { ReactTablesContext } from 'components/ReactTable';
import { ReactComponent as FilterIcon } from 'assets/img/icons/filter.svg';

export default function TableFilterButton({
  expand = false,
  onClick = () => {},
  textWhenActive = 'Filters*',
  textWhenInactive = 'Filters',
  className = ''
}) {
  const {
    checkIfRefined,
    searchState: { isFetchingFacets, isFacetsFetchingError }
  } = useContext(ReactTablesContext);

  const isFilterActive = checkIfRefined();

  const buttonText = isFilterActive ? textWhenActive : textWhenInactive;

  return (
    <UiKit.Button
      variant="outline"
      onClick={onClick}
      processing={isFetchingFacets}
      disabled={isFacetsFetchingError}
      className={cn('table-filter-button', className)}
    >
      <FilterIcon className="table-filter-button__icon" />
      <span>{buttonText}</span>
    </UiKit.Button>
  );
}
